import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Table, Input, Space, Tag } from 'antd';

const { Title } = Typography;

const AuditLogs = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [query, setQuery] = useState('');

  const columns = [
    { title: 'Time', dataIndex: 'created_at', key: 'created_at', width: 180 },
    { title: 'User ID', dataIndex: 'user_id', key: 'user_id', width: 100 },
    { title: 'Event', dataIndex: 'event_type', key: 'event_type', width: 160, render: v => v ? <Tag>{v}</Tag> : '-' },
    { title: 'Page', dataIndex: 'page', key: 'page', width: 200 },
    { title: 'Feature', dataIndex: 'feature', key: 'feature', width: 160 },
    { title: 'Element', dataIndex: 'element', key: 'element', width: 200 },
    { title: 'Duration (ms)', dataIndex: 'duration_ms', key: 'duration_ms', width: 130 },
    { title: 'Entity', dataIndex: 'entity', key: 'entity', width: 180 },
    { title: 'Details', dataIndex: 'details', key: 'details' },
  ];

  useEffect(() => {
    let isMounted = true;
    async function fetchEvents() {
      try {
        setLoading(true);
        const res = await fetch('/api/audit-events?limit=200');
        if (!res.ok) throw new Error('Failed to load audit events');
        const data = await res.json();
        const items = Array.isArray(data?.items) ? data.items : [];
        const mapped = items.map((e) => ({
          id: e.id,
          created_at: e.created_at ? new Date(e.created_at).toLocaleString() : '-',
          user_id: e.user_id ?? '-',
          event_type: e.event_type ?? '',
          page: e.page ?? '',
          feature: e.feature ?? '',
          element: e.element ?? '',
          duration_ms: e.duration_ms ?? 0,
          entity: e.entity_type && e.entity_id ? `${e.entity_type} #${e.entity_id}` : '',
          details: e.metadata ? (() => { try { return typeof e.metadata === 'string' ? e.metadata : JSON.stringify(e.metadata); } catch { return ''; } })() : '',
        }));
        if (isMounted) setRows(mapped);
      } catch (err) {
        console.error(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    }
    fetchEvents();
    return () => { isMounted = false; };
  }, []);

  const filtered = rows.filter(r => {
    if (!query) return true;
    const q = query.toLowerCase();
    return (
      String(r.user_id).toLowerCase().includes(q) ||
      (r.event_type || '').toLowerCase().includes(q) ||
      (r.page || '').toLowerCase().includes(q) ||
      (r.feature || '').toLowerCase().includes(q) ||
      (r.element || '').toLowerCase().includes(q) ||
      (r.entity || '').toLowerCase().includes(q) ||
      (r.details || '').toLowerCase().includes(q)
    );
  });

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Admin' }, { title: 'System' }, { title: 'Audit Logs' }]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Audit Logs</Title>
        <Space>
          <Input.Search allowClear placeholder="Search logs" onSearch={setQuery} onChange={e => setQuery(e.target.value)} style={{ width: 320 }} />
        </Space>
      </div>

      <Card>
        <Table
          rowKey={(r) => r.id || `${r.created_at}-${r.user_id}-${r.event_type}-${r.page}`}
          columns={columns}
          dataSource={filtered}
          loading={loading}
          pagination={{ pageSize: 15 }}
          scroll={{ x: 1100 }}
        />
      </Card>
    </div>
  );
};

export default AuditLogs;
